import { ACTIONS } from '../actions';

const INITIAL_STATE = {
    status: false,
    isError: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.CHECK_STATUS_FILE:
            if(action.payload.status === 200) {
                return { ...state, status: action.payload.data, isError: false };
            } else {
                return { ...state, message: action.payload.response.data.message, isError: true };
            }
        default:
            return state;
    }
}